/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_HelpInputs */

const he_command_help = /** @type {(inputs: Command_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עזרה`)
};

const en_command_help = /** @type {(inputs: Command_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help`)
};

/**
* | output |
* | --- |
* | "Help" |
*
* @param {Command_HelpInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const command_help = /** @type {((inputs?: Command_HelpInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_HelpInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_command_help(inputs)
	return en_command_help(inputs)
});